import * as React from 'react';
import TextInput from '@packages/systems/design-system/TextInput';
import {Label} from './LinkUIComponents';
import {dissoc} from '@packages/utilities/key-map';
import {Note} from '@packages/systems/spring';
import type {State} from './LinkTypes';

export const useTel = (state: State, dispatch: (arg1?: any) => void) => {
  const [tel = '', setTel] = React.useState(state.tel);

  const onChange = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setTel(e.currentTarget.value);

  const onBlur = React.useCallback(() => {
    let newState = {...state, tel};

    // Remove `tel` from data when blank
    if (tel === '') {
      // @ts-expect-error - TS2739 - Type '{ [key: string]: any; }' is missing the following properties from type '{ tel: string; mode: Mode; url?: string | undefined; pageId?: string | undefined; domId?: string | undefined; email?: string | undefined; subject?: string | undefined; assetId?: string | undefined; target?: "_self" | ... 1 more ... | undefined; preload?: "none" | ... 2 more ... | undefined; }': tel, mode
      newState = dissoc('tel')(newState);
    }
    dispatch({
      payload: newState,
      meta: {analytics: {type: 'element-settings-updated', value: 'phone'}},
    });
  }, [dispatch, state, tel]);

  React.useEffect(() => setTel(state.tel), [state.tel]);

  return {onChange, onBlur, tel};
};

export const LinkTelMode = ({
  state,
  dispatch,
  isOverride,
  hasLegacyDynamoHrefBinding,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
  isOverride: boolean;
  hasLegacyDynamoHrefBinding?: boolean;
}) => {
  const {tel, onChange, onBlur} = useTel(state, dispatch);

  return (
    <>
      {/* Tel */}
      {hasLegacyDynamoHrefBinding ? null : (
        <>
          <Label
            data-automation-id="symbols-dataType-contentType"
            isOverride={isOverride}
          >
            Phone
          </Label>
          <TextInput
            data-automation-id="Type--Plugin_Text_Phone"
            onBlur={onBlur}
            onChange={onChange}
            placeholder="e.g. +14155551212"
            type="text"
            value={tel}
          />
        </>
      )}
      <Note
        style={{gridColumn: '1 / -1'}}
        colorVariant="default"
        hasIcon={false}
      >
        Phone links only work on devices that can place phone calls.
      </Note>
    </>
  );
};
